export const initialPasswordConfig = {
  minLength: 6,
  maxLength: 50,
  requireDigits: true,
  requireLowercaseLetters: true,
  requireSpecialSymbols: true,
  requireUppercaseLetters: true,
};
